"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EyeClosedOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M27.77 7.37a1 1 0 0 0-1.4-.14L23.7 9.41A13.91 13.91 0 0 0 16.11 7C9.69 7 4.72 12 2.46 14.72a2 2 0 0 0 0 2.58 26.838 26.838 0 0 0 5.43 5l-3.53 2.9a1 1 0 0 0-.14 1.4A1 1 0 0 0 5 27a.94.94 0 0 0 .63-.23l4.09-3.34 2.73-2.24 2.8-2.29 3.73-3 2.57-2.1 6.07-4.98a1 1 0 0 0 .15-1.45ZM8 16a8 8 0 0 0 1.67 4.88l-.15.12A24.41 24.41 0 0 1 4 16a23.88 23.88 0 0 1 5.87-5.13A7.94 7.94 0 0 0 8 16Zm8-1.5c0 .34.121.67.34.93L20.49 12A6 6 0 0 0 10 16a5.89 5.89 0 0 0 1.23 3.61l2.33-1.9A3 3 0 0 1 16 13c.302 0 .602.047.89.14A1.48 1.48 0 0 0 16 14.5Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M29.53 14.7a33.698 33.698 0 0 0-2.61-2.77L22 16a6 6 0 0 1-6 6 5.578 5.578 0 0 1-1.23-.13l-3 2.44c1.32.453 2.705.686 4.1.69 6.41 0 11.39-5 13.65-7.72a2 2 0 0 0 .01-2.58Zm-7.41 6.44A8.09 8.09 0 0 0 23.94 17l2.85-2.33c.4.43.81.89 1.22 1.36a24 24 0 0 1-5.89 5.11Z" clip-rule="evenodd"></path></g>';
var EyeClosedOutlineSVG = function EyeClosedOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.EyeClosedOutlineSVG = EyeClosedOutlineSVG;
EyeClosedOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(EyeClosedOutlineSVG);
exports.default = _default;